import {
  defineLazyUrlProperties,
  resolveRegionalApiUrl,
} from "../helper/runtime-api-url-box";

export interface ISignlarConstants {
    chat: {
        negotiateUrl: string,
        sendMessage: string,
    },
    general: {
        appInsightsSendToOthersError: string,
        appInsightsSendToUserByIdError: string,
        appInsightsSendToALLError: string,
        appInsightsConnectionState: string,
        appInsightsStartConnectionError: string,
    }
}

const signalrBase = () => resolveRegionalApiUrl("VITE_SignalRAzureFuncUrl");

export const signalrConstants: ISignlarConstants = {
  chat: defineLazyUrlProperties({
    negotiateUrl: () => `${signalrBase()}/api/signalr/negotiate`,
    sendMessage: () => `${signalrBase()}/api/signalr-send-message`,
  }),
  general: {
    appInsightsSendToOthersError: "UI: Signalr-SendToOthersError",
    appInsightsConnectionState: "UI: Signalr-ConnectionState",
    appInsightsSendToALLError: "UI: Signalr-SendToALL-Error",
    appInsightsStartConnectionError: "UI: Signalr-StartConnection-Error",
    appInsightsSendToUserByIdError: "UI: Signalr-SendToUserById-Error",
  },
};
